<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="700px">
      <v-form v-model="valid" ref="formData">
        <v-card class="pt-3">
          <v-card-title>
            <span class="headline ml-2">{{isEdit ? $t('edit') : $t('add')}} {{$t('component')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col cols="12" sm="12" md="12" class="pt-0 pb-0 mt-0 mb-0">
                  <label>{{$t('component_type')}}</label>
                  <v-radio-group  v-if="company_id != 'pt-laundrykotakindonesia'" v-model="dataItem.type" row :rules="rules" required>
                    <v-radio
                      :value="item.id"
                      :label="item.typeName_id"
                      v-for="(item,i) in typeComponent"
                      v-bind:key="i"
                    ></v-radio>
                  </v-radio-group>
                  <v-radio-group v-else v-model="dataItem.type" row :rules="rules" required>
                    <v-radio
                      :value="item.id"
                      :label="item.typeName_id"
                      v-for="(item,i) in typeComponentHide"
                      v-bind:key="i"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="pt-0 pb-0 mt-0 mb-0">
                  <v-text-field
                    :disabled="isEdit"
                    :label="$t('component_code')"
                    v-model="dataItem.componentCode"
                    :rules="[...rules3, validator.alfaNumberNotRequired]"
                    max="8"
                    class="sae-required"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="pt-0 pb-0 mt-0 mb-0">
                  <v-text-field
                     :label="$t('component_name')"
                    v-model="dataItem.name"
                    :rules="[...rules, validator.componentRequired]"
                    required
                    class="sae-required"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0 mt-0 mb-0">
                  <v-label>{{$t('config_component_value')}}</v-label>
                </v-col>
                <v-col md="6" class="pt-0 pb-0 mt-0 mb-0">
                  <v-switch
                    v-model="dataItem.fixValue"
                    :label="$t('fixed_value')"
                    inset
                    color="success"
                    value
                    input-value="false"
                  ></v-switch>
                </v-col>
                <v-col md="12" v-if="!dataItem.fixValue" class="pt-0 pb-0 mt-0 mb-0 sae-mdi">
                  <v-textarea
                     :label="$t('formula')"
                    rows="1"
                    auto-grow
                    v-model="dataItem.formula"
                    required
                    class="sae-required"
                    prepend-icon="mdi-function"
                    @click:prepend="formulaDialog = true"
                    @click="showFormulaDialog"
                    :disabled="dataItem.positionOnly"
                    :rules="rules3a"
                  ></v-textarea>
                </v-col>
                <v-col md="12" v-if="dataItem.fixValue" class="pt-0 pb-0 mt-0 mb-0">
                  <v-text-field
                    v-if="dialog"
                    type="text"
                    :label="$t('amount')"
                    v-model="dataItem.amount"
                    v-mask="mask"
                    :rules="rules3b"
                    required
                    class="sae-required"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0 mt-0 mb-0">
                  <v-label>{{$t('tax')}}</v-label>
                </v-col>
                <v-col cols="6" class="pt-0 pb-0 mt-0 mb-0">
                  <v-switch
                    inset
                    color="success"
                    :label="$t('activate_tax_calc')"
                    v-model="dataItem.taxable"
                  ></v-switch>
                </v-col>
                <v-col cols="12" v-if="dataItem.taxable" class="pt-0 pb-0 mt-0 mb-0">
                  <v-autocomplete
                    :items="taxList"
                   :label="$t('pick_parameter')"
                    item-text="title"
                    item-value="id"
                    v-model="dataItem.taxParameterId"
                    :rules="rules"
                    class="sae-required"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0 mt-0 mb-0">
                  <v-label>{{$t('calculation_method')}}</v-label>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0 mt-0 mb-0">
                  <v-switch
                    inset
                    color="success"
                    label="Aktifkan Metode Perhitungan (prorate)"
                    value
                    v-model="dataItem.calculateMethod"
                  ></v-switch>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0 mt-0 mb-0">
                  <v-label>Tunjangan</v-label>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0 mt-0 mb-0">
                  <v-switch
                    inset
                    color="success"
                    :label="$t('activate_position_allowance')"
                    value
                    v-model="dataItem.positionOnly"
                  ></v-switch>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0 mt-0 mb-0">
                  <v-select
                    :items="[{id: false, name: $t('inactive')},{id: true, name: $t('active')}]"
                    :label="$t('status')"
                    item-text="name"
                    item-value="id"
                    v-model="dataItem.status"
                    :rules="rules2"
                    class="sae-required"
                    required
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-6 pb-6">
            <v-row justify="center">
              <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
              <v-btn
                :loading="loading"
                color="primary"
                @click="saveOrUpdate(dataItem)"
                :disabled="!valid"
              >
                <!-- <template v-slot:loader>
                  <v-icon dark class="spin">mdi-radioactive</v-icon>
                </template>-->
                {{$t('save')}}
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="deleteDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline">{{$t('delete_component')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" :loading="loading" @click="deleteComponent(dataItem)">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="formulaDialog" max-width="900">
      <formula-generator
        v-if="formulaDialog"
        v-bind:formula="dataItem.formula"
        @save="setFormula"
        @cancel="closeFormulaDialog"
      ></formula-generator>
    </v-dialog>

    <v-layout row v-if="!sortingView">
      <v-flex shrink>
        <v-layout row>
          <v-flex shrink class="ml-4 mt-5 pt-4 pl-2" style="color:rgba(0,0,0,0.7)">
             {{$t('status')}}:
          </v-flex>
          <v-flex md6 class="pl-4 mt-3">
            <v-select
              :items="[{id: 0, name: $t('active')},{id: 1, name: $t('all')}]"
              item-text="name"
              item-value="id"
              v-model="activeOnly"
              @change="refreshData($event?0:1)"
            ></v-select>  
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex>
        <v-text-field
          :rules="[validator.alfaNumberNotRequired]"
           :label="$t('search')"
          prepend-inner-icon="mdi-magnify"
          single-line
          v-model="search"
        ></v-text-field>
      </v-flex>
      <v-flex>
        <v-row>
          <v-col cols="12">
            <v-btn
              right
              color="primary"
              dark
              outlined
              class="ml-2 mb-2 float-right"
              v-if="!sortingView"
              @click="sortingView = true"
            >{{$t('sort_report')}}</v-btn>
            <v-btn right color="primary" outlined dark class="float-right mb-2" @click="addItem">{{$t('add_component')}}</v-btn>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <sorting-component
      v-if="sortingView"
      :headers="sortingHeader"
      :list="dataList"
      @save="saveSorting($event)"
      @cancel="cancelSorting"
    />

    <v-data-table
      v-if="!sortingView"
      :search="search"
      :items="dataList"
      :headers="headers"
      :no-data-text="$t('no_data')"
      class="sae elevation-1 mt-3"
      :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }"
    >
     <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
      <template
        v-slot:item.no="{ item }"
      >{{dataList.map(function(x) {return x.id; }).indexOf(item.id) + 1}}</template>
      <template v-slot:item.componentCode="{ item }">
        <span style="color: #3277D5">
          {{ item.componentCode }} 
          <span v-if="item.componentCode === baseSalaryDefaultCode">
            (default)
          </span>
        </span>
      </template>
      <template v-slot:item.status="{ item }">
        <div v-if="item.status" class="text-center">
          <v-tooltip top color="success">
            <template v-slot:activator="{ on, attrs }">
              <b v-bind="attrs" v-on="on" class="cursor">
                <v-icon small color="success">mdi-check-circle-outline</v-icon>
              </b>
            </template>
            <span>{{$t('active')}}</span>
          </v-tooltip>
        </div>
        <div v-else class="text-center">
          <v-tooltip top color="error">
            <template v-slot:activator="{ on, attrs }">
              <b v-bind="attrs" v-on="on" class="cursor">
                <v-icon small color="error">mdi-alert-circle-outline</v-icon>
              </b>
            </template>
            <span>{{$t('inactive')}}</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:item.positionOnly="{ item }">
        <div v-if="item.positionOnly" class="text-center">
          <v-tooltip top color="success">
            <template v-slot:activator="{ on, attrs }">
              <b v-bind="attrs" v-on="on" class="cursor">
                <v-icon small color="success">mdi-check-circle-outline</v-icon>
              </b>
            </template>
            <span>{{$t('have_allowance')}}</span>
          </v-tooltip>
          
        </div>
        <div v-else class="text-center">
          <v-tooltip top color="error">
            <template v-slot:activator="{ on, attrs }">
              <b v-bind="attrs" v-on="on" class="cursor">
                <v-icon small color="error">mdi-alert-circle-outline</v-icon>
              </b>
            </template>
            <span>{{$t('no_allowance')}}</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:item.type="{ item }">
            <div>{{$t(item.type)}}</div>
      </template>
      <template v-slot:item.action="{ item }">
        <v-row>
          <v-btn icon :disabled="!item.isEditable" color="primary" @click="editedItem(item)" small>
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon :disabled="!item.isDeletable" color="error" @click="deleteItem(item)" small>
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import FormulaGenerator from './FormulaGenerator.vue';
import SortingComponent from './SortingComponent.vue';

export default {
  components: {
    FormulaGenerator,
    SortingComponent,
  },
  name: "config-component",
  data() {
    return {
      mask: null,
      formulaDialog: false,
      activeOnly: 1,
      isEdit: false,
      deleteScheduleTime: false,
      dialog: false,
      deleteDialog: false,
      typeComponent: [
        { id: 1, typeName_id: this.$i18n.t('allowance') },
        { id: 2, typeName_id: this.$i18n.t('deduction') },
        { id: 3, typeName_id: this.$i18n.t('neutral') }
      ],
      typeComponentHide: [
        { id: 1, typeName_id: this.$i18n.t('allowance') },
        { id: 2, typeName_id: this.$i18n.t('deduction') },
        { id: 3, typeName_id: this.$i18n.t('neutral') },
        { id: 4, typeName_id: this.$i18n.t('hide') }
      ],
      dataList: [],
      taxList: [],
      headers: [
        { text: "No", value: "no" },
        { text: this.$i18n.t('component_code'), value: "componentCode" },
        { text: this.$i18n.t('component_type'), value: "type" },
        { text: this.$i18n.t('component_name'), value: "name" },
        { text: this.$i18n.t('calculation_formula'), value: "formula" },
        { text: this.$i18n.t('status'), value: "status" },
        { text: this.$i18n.t('position_allowance'), value: "positionOnly", center: 'center' },
        { text: this.$i18n.t('action'), value: "action" },
      ],
      sortingHeader: ['componentCode', 'name', 'typeEn'],
      sortingView: false,
      company_id: this.$store.state.company,
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      dataItem: {
        id: 0,
        name: "",
        formula: "",
        status: true,
        type: 1,
        componentCode: null,
        taxable: false,
        taxParameterId: null
      },
      search: "",
      editedIndex: -1,
      valid: true,
      rules: [(v) => !!v || this.$i18n.t('required')],
      rules2: [(value) => (value == 0 ? true : value ? value > 0 : !!value || this.$i18n.t('required'))],
      rules3: [(v) => !!v || this.$i18n.t('required'), (v) => (v ? v.length <= 8 : false) || 'Max 8 Char'],
      rules3b: [v => !!v || this.$i18n.t('required'), v => /^[0-9\-.,]+$/.test(v) || 'Only accept numbers', v => (v || '').length <= 14 || '11 Char Max'],
      rules3a: [
        v => /^[+/*\- ()<>%.,0-9a-zA-Z]+$/.test(v) || this.$i18n.t('accept_only_alfanumberic')
      ],
      loading: false,
      firstLoadFormula: true,
      baseSalaryDefaultCode: 'T01'
    };
  },
  methods: {
    closeFormulaDialog() {
      this.formulaDialog = false
      setTimeout(() => {
        this.firstLoadFormula = true
      }, 1000);
    },
    changePositionOnly() {
      this.dataItem.formula = null
    },
    async saveSorting(data) {
      const result = await this.$store.dispatch('editSortingComponent', { data })
      if (result) {
        this.showMessage('success', 'Data Sorting Saved')
        this.cancelSorting()
        this.refreshData(this.activeOnly === 0 ? 1 : 0)
      }
    },
    cancelSorting() {
      this.sortingView = false
    },
    setFormula(event) {
      this.dataItem.formula = event
      this.formulaDialog = false
      setTimeout(() => {
        this.firstLoadFormula = true
      }, 1000);
    },
    showFormulaDialog() {
      if (this.firstLoadFormula) {
        this.firstLoadFormula = false
        this.formulaDialog = true
      }
    },
    costumHeader(action, actionId) {
      return { headers: { action, actionId } }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    async getTax() {
      return await this.$store.dispatch('getTax')
    },
    async getPayrollComponent(status = 1) {
      return await this.$store.dispatch('getPayrollComponent', { status })
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editPayrollComponent(data)
      } else {
        this.savePayrollComponent(data)
      }
    },
    async savePayrollComponent(data) {
      await this.beforeSave()
      const body = { ...data, typeId: data.type }
      this.loading = true
      const result = await this.$store.dispatch('savePayrollComponent', body)
      if (result == true) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialog = false
        this.dataList = await this.getPayrollComponent()
      }
      this.loading = false
      await this.afterSave()
    },
    async editPayrollComponent(data) {
      await this.beforeSave()
      const body = { ...data, typeId: data.type }
      this.loading = true
      const result = await this.$store.dispatch('editPayrollComponent', body)
      if (result == true) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.dialog = false
        this.dataList = await this.getPayrollComponent()
      }
      this.loading = false
      await this.afterSave()
    },
    async deleteComponent(data) {
      this.loading = true
      const result = await this.$store.dispatch('deletePayrollComponent', data)
      if (result == true) {
        this.showMessage('success', 'Data Deleted')
        this.deleteDialog = false
        this.dataList = await this.getPayrollComponent()
      }
      this.loading = false
    },
    addItem() {
      this.firstLoadFormula = true
      this.isEdit = false
      this.dataItem = Object.assign({}, { id: 0, name: "", formula: "", status: true, type: 1, componentCode: null, taxable: false, taxParameterId: null, calculateMethod: false, fixValue: false })
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    editedItem(item) {
      this.firstLoadFormula = true
      this.isEdit = true
      this.dataItem = Object.assign({}, item);
      this.dataItem.type = item.typeId
      this.dialog = true
    },
    deleteItem(item) {
      this.dataItem = Object.assign({}, item);
      this.deleteDialog = true;
    },
    async refreshData(status = 0) {
      this.dataList = await this.getPayrollComponent(status)
    },
    async beforeSave() {
      this.mask = await this.$store.dispatch('getNumberMaskFormat', false)
    },
    async afterSave() {
      this.mask = await this.$store.dispatch('getNumberMaskFormat')
    },
  },
  async beforeMount() {
    this.mask = await this.$store.dispatch('getNumberMaskFormat')
  },
  async created() {
    this.dataList = await this.getPayrollComponent(0)
    this.taxList = await this.getTax()
  },
  watch: {
    dialog(show) {
      if (show && !this.isEdit) {
        if (this.$refs.formData) {
          this.$refs.formData.reset();
          setTimeout(() => { this.dataItem = { id: 0, name: "", formula: "", status: true, type: 1, componentCode: null, taxable: false, taxParameterId: null, calculateMethod: false } }, 20)
        }
      }
    },
  },
};
</script>
<style>
.sae-lightgrey {
  background-color: rgba(0, 0, 0, 0.03) !important;
  border-color: rgba(0, 0, 0, 0.03) !important;
}
.sae .v-data-table-header th {
  text-align: center !important;
}
.sae-mdi .mdi {
  color: #1976d2 !important;
  /* background-color: #1976d2 !important; */
}
</style>